import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

interface ButtonData {
	buttonLabel: string;
	buttonIcon: string;
  buttonLoading: boolean;
}

@Component({
	selector: 'app-split-button',
	standalone: true,
	imports: [MatButtonModule, MatIconModule, TranslateModule, MatProgressSpinnerModule],
	templateUrl: './split-button.component.html',
	styleUrl: './split-button.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class SplitButtonComponent {
	@Input() buttonsData: ButtonData = {
		buttonLabel: '',
		buttonIcon: '',
    buttonLoading: false
	};
	@Output() clickedButton: EventEmitter<string> = new EventEmitter();

	buttonAction(button: 'MAIN' | 'SECONDARY') {
		this.clickedButton.emit(button);
	}
}
